import {
  Button,
  Checkbox,
  FormControl,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
  VStack,
} from "@chakra-ui/react";
import { useCallback } from "react";
import { db, Student } from "../db";

interface StudentConsentDialogProps {
  isOpen: boolean;
  onClose: () => void;
  students: Student[];
  updateStudents: () => void;
  onDownloadData: () => void;
}

const StudentConsentDialog = ({
  isOpen,
  onClose,
  students,
  updateStudents,
  onDownloadData,
}: StudentConsentDialogProps) => {
  const setDataCollectionConsent = useCallback(
    async (studentId: number, dataCollectionConsent: boolean) => {
      try {
        await db.students.update(studentId, {
          edited: true,
          dataCollectionConsent,
        });
        await updateStudents();
      } catch (err) {
        console.error(`Failed to update student: ${err}`);
      }
    },
    [updateStudents]
  );

  const handleConfirm = useCallback(async () => {
    onDownloadData();
    onClose();
  }, [onClose, onDownloadData]);

  return (
    <Modal isOpen={isOpen} onClose={onClose} scrollBehavior="inside">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Check consent settings</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <VStack spacing={5}>
            <Text>
              Please check that the consent settings below are correct before
              continuing:
            </Text>
            {students.map((student) => (
              <FormControl alignSelf="flex-start" width="auto">
                <Checkbox
                  isChecked={student.dataCollectionConsent}
                  onChange={(e) =>
                    setDataCollectionConsent(student.id!, e.target.checked)
                  }
                >
                  <Text>{`Student ${student.number}${
                    student.name !== `Student ${student.number}`
                      ? ` (${student.name})`
                      : ""
                  }`}</Text>
                </Checkbox>
              </FormControl>
            ))}
          </VStack>
        </ModalBody>
        <ModalFooter>
          <Button colorScheme="blue" onClick={handleConfirm}>
            Confirm and download
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default StudentConsentDialog;
